import React from "react";
import styles from "./about.module.css";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/footer/footer";
import HeroSection from "../../components/aboutHero/aboutHeroSection";
import Card from "../../components/cardPerson/index";
import walidImage from "../../assets/images/boardOfDirectors/Mr_Walid.png";
import anonymousImage from "../../assets/images/boardOfDirectors/anonymousPerson.png";
import classes from "../ourTeam/ourTeam.module.css";
import CFHManagment from "../../data/CFHManagement";
const values = [
  {
    title: "Integrity",
    content:
      "Integrity is at the heart of everything we do at Cairo Capital. We uphold ethical practices, transparency, and honesty in every interaction, ensuring our clients are fully informed about risks, opportunities, and outcomes. By fostering trust at every stage of the financial journey, we build lasting relationships. This commitment is reinforced through clear communication, strict compliance with industry standards, and an unwavering dedication to acting in our clients’ best interest.",
  },
  {
    title: "Effectiveness",
    content:
      "Cairo Capital is dedicated to achieving tangible results by leveraging deep market expertise, advanced analytics, and a performance-driven mindset. The company ensures its strategies are tailored to client goals, delivering consistent returns and value. Operational excellence is reinforced through efficient processes, seamless execution of transactions, and a proactive approach to identifying and capitalizing on market opportunities.",
  },
  {
    title: "Accountability",
    content:
      "Cairo Capital stands by its promises, maintaining transparency in outcomes and operations. Clients are provided with detailed, regular reporting and updates, ensuring full visibility into the management of their portfolios. By proactively addressing challenges and taking responsibility for decisions, the company builds enduring relationships based on mutual respect and trust.",
  },
  {
    title: "Customer Centricity",
    content:
      "Cairo Capital focuses on creating bespoke solutions that align with each client’s unique aspirations and financial needs. Dedicated relationship managers ensure personalized attention, while the firm’s flexible service model adapts to the evolving goals of its diverse clientele. By actively listening and delivering customized services, Cairo Capital fosters loyalty and satisfaction among its clients.",
  },
  {
    title: "Courage",
    content:
      "Courage defines our approach to leadership and innovation. At Cairo Capital, we embrace well-studied opportunities that have undergone rigorous due diligence and reveal hidden value. Through forward-thinking strategies, we uncover potential in emerging markets, technologies, and investment trends, delivering “investment-ready” opportunities to our clients. In uncertain environments, our resilience and vision enable us to navigate complexities, safeguard wealth, and deliver value. By consistently providing innovative and adaptable solutions, we ensure our clients are prepared to thrive in an ever-evolving financial future.",
  },
  {
    title: "Innovation",
    content:
      "Cairo Capital integrates cutting-edge technology, such as AI-driven analytics and digital tools, to provide smarter, faster, and more adaptive financial solutions. By staying ahead of industry trends and continuously enhancing its service offerings, the firm delivers state-of-the-art platforms for portfolio management, risk assessment, and client engagement. This innovative approach ensures clients are equipped to thrive in a rapidly evolving financial landscape.",
  },
];
const about = () => {
  const cardData = [
    {
      header: "Tawfik Diab",
      paragraph: "Chairman & CEO",
    },
    {
      header: "Amr Al Badry (ADI)",
      paragraph: "Board Member",
    },
    {
      image: walidImage,
      header: "Walid El Ogail (ADI)",
      paragraph: "Board Member",
    },
    {
      image: anonymousImage,
      header: "Salah Shafei",
      paragraph: "Pico Investments",
    },
    {
      image: anonymousImage,
      header: "Sherif Al Akhdar",
      paragraph: "Board Member",
    },
    {
      image: anonymousImage,
      header: "Noha Mansour",
      paragraph: "Board Member",
    },
  ];
  return (
    <div>
      <NavBar />
      <HeroSection />

      <div className={styles.container}>
        <h2 className={styles.header}>Board of Directors</h2>
        <div className={styles.cardsContainer}>
          {cardData.slice(0, 3).map((card, index) => (
            <Card
              key={index}
              header={card.header}
              paragraph={card.paragraph}
              largeCardItem={true}
            />
          ))}
        </div>
        <div className={styles.cardsContainer}>
          {cardData.slice(3).map((card, index) => (
            <Card
              key={index}
              header={card.header}
              paragraph={card.paragraph}
              largeCardItem={true}
            />
          ))}
        </div>
      </div>
      <div className={styles.textSection}>
        <h2 className={styles.header1}>Our Approach</h2>
        <p className={styles.paragraph1}>
          “Our approach is defined by diligence, precision, and innovation. From
          uncovering hidden value in listed entities to identifying
          transformative opportunities in private equity, we combine deep market
          expertise and agility with cutting-edge technology to deliver
          investments that the broader market has yet to recognize. Every
          opportunity we offer is rigorously vetted, fully prepared, and ready
          to transact, ensuring seamless execution and minimizing risk for our
          clients. We believe that creating wealth isn’t just about maximizing
          returns—it’s about delivering real solutions, empowering informed
          decisions, and crafting a legacy of sustained success.”
        </p>
        {
          // <p className={styles.paragraph2}>Eng. Tawfik Salah El Din Ahmed Diab</p>
        }
      </div>

      <div className={styles.parentContainer}>
        <h2 className={styles.header1}>Our Values</h2>
        <div className={styles.containerValues}>
          {values.map((value, index) => (
            <div className={styles.card} key={index}>
              <h3>{value.title}</h3>
              <p>{value.content}</p>
            </div>
          ))}
        </div>
      </div>
      <div className={classes.container}>
        <h2 className={classes.header}>CFH Management Team</h2>
        <div className={styles.cardsContainer}>
          {CFHManagment.slice(0, 3).map((card, index) => (
            <Card
              key={index}
              header={card.header}
              paragraph={card.paragraph}
              largeCardItem={true}
            />
          ))}
        </div>
        <div className={styles.cardsContainer}>
          {CFHManagment.slice(3).map((card, index) => (
            <Card
              key={index}
              header={card.header}
              paragraph={card.paragraph}
              largeCardItem={true}
              responsiveImage={card.responsiveImage}
              responsiveImageChecked={true}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default about;
